module.exports = __webpack_public_path__ + "img/es-pc-step-1.29bd3ec9.png";